<app-table
  [lazy]="true"
  [cols]="columns"
  tableTitle="Benefícios divergentes"
  [addButton]="false"
  [exportPdf]="false"
  [exportExcel]="false"
  [refreshButton]="false"
  [service]="bfluenceIntegrityService"
  pageFunctionName="getDivergentSubscriberBenefitTable"
  emptyMessage="Sem mais benefícios divergentes no momento."
  selectionActionLabel="Corrigir"
  selectionActionTooltip="Marcar como resolvido"
  selectionActionIcon="pi pi-check"
  (emitSelection)="markAsResolved($event)"
  modelName="registros"
  [defaultRows]="10"
></app-table>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
